import React from "react";
import PropTypes from "prop-types";

export default function UpgradePrice({ upgradePrice }) {
  if (upgradePrice.price || upgradePrice.errorMessage) {
    return <span>{upgradePrice.price || upgradePrice.errorMessage}</span>;
  }
  return (
    <span>
      <i className="lc-spinner fa fa-cog fa-spin fa-fw" />
      <small>LOADING</small>
    </span>
  );
}

UpgradePrice.propTypes = {
  upgradePrice: PropTypes.shape({
    errorMessage: PropTypes.string,
    price: PropTypes.string
  }).isRequired
};
